import MapMarker from './dom';
export default MapMarker;
